// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fVTic{display:flex;align-items:center;justify-content:center;flex-direction:column;gap:24px;min-height:100%;padding:24px;text-align:center}.C3WKz{display:flex;flex-direction:column;gap:16px;width:100%;max-width:420px}.ATi8D{width:100%;display:flex;flex-direction:row;justify-content:space-between;align-items:center;border:1px solid #e0e0e0;padding:8px 24px;box-shadow:0px 1px 2px 0px #2828631A;gap:16px}.Y9w0F{max-width:1020px;text-align:center}.NYGBm{flex-shrink:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"acceptInvitationPageContainer": `fVTic`,
	"invitationsContainer": `C3WKz`,
	"invitationContainer": `ATi8D`,
	"description": `Y9w0F`,
	"logoContainer": `NYGBm`
};
export default ___CSS_LOADER_EXPORT___;
